import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Header2, Title2, Button, ArrowLeftIcon, IconButton } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makeGetIsSuspendedSelector } from "~/store/selectors/selector.configOptions";

const SubscriptionHeader = ({ title, backRoute, className, renderBackToProjects }) => {
  const { t } = useTranslation();
  const isSuspendedSelector = useMemo(() => makeGetIsSuspendedSelector(), []);
  const isSuspended = useSelector(isSuspendedSelector);

  return (
    <div className={classNames("tw-flex tw-items-center tw-justify-between tw-my-3 tw-h-10", className)}>
      <div className="tw-flex">
        {backRoute ? (
          <Link to={backRoute}>
            <IconButton
              variant="text gray"
              className="tw-mr-2"
            >
              <ArrowLeftIcon />
            </IconButton>
          </Link>
        ) : null}
        {title ? (
          <>
            <Title2 className="tw-hidden md:tw-block tw-mr-2 tw-truncate">{title}</Title2>
            <Header2
              weight="light"
              className="tw-block md:tw-hidden tw-mr-2 tw-truncate"
            >
              {title}
            </Header2>
          </>
        ) : null}
      </div>
      {!isSuspended && renderBackToProjects ? (
        <Link to="/projects">
          <Button variant="outlined">{t("Back to Projects")}</Button>
        </Link>
      ) : null}
    </div>
  );
};

SubscriptionHeader.displayName = "SubscriptionHeader";

SubscriptionHeader.propTypes = {
  className: PropTypes.string,
  backRoute: PropTypes.string,
  title: PropTypes.string,
  renderBackToProjects: PropTypes.bool,
};

SubscriptionHeader.defaultProps = {
  title: "",
  renderBackToProjects: true,
};

export default SubscriptionHeader;
